import React from "react";

class ErrorBoundary extends React.Component {
  state = { hasError: true };

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Error boundary caught an error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      console.error(this.state.hasError);
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
